import theme from '@/presentation/assets/styles/theme'
import { ThemeProvider } from '@emotion/react'
import { CssBaseline } from '@mui/material'
import { ReactNode } from 'react'
import { QueryClientProvider } from 'react-query'
import { ApplicationSettingsProvider } from './application/application-settings-provider'
import { AccountProvider } from './auth/account-provider'
import { queryClient } from '@/infra/http'

type AppProvidersProps = {
  children: ReactNode
}

export default function AppProviders({ children }: AppProvidersProps) {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <AccountProvider>
          <ApplicationSettingsProvider>{children}</ApplicationSettingsProvider>
        </AccountProvider>
      </QueryClientProvider>
    </ThemeProvider>
  )
}
